import { render, staticRenderFns } from "./bannerMenu.vue?vue&type=template&id=44d8553d&scoped=true"
import script from "./bannerMenu.vue?vue&type=script&lang=js"
export * from "./bannerMenu.vue?vue&type=script&lang=js"
import style0 from "./bannerMenu.vue?vue&type=style&index=0&id=44d8553d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d8553d",
  null
  
)

export default component.exports